import { Pipe, PipeTransform } from '@angular/core';
import { ContractType } from '@app/features/contracts/contract.model';

@Pipe({
  name: 'contractTypeFullName',
})
export class ContractTypeFullNamePipe implements PipeTransform {
  transform(contractType: ContractType | null | undefined): string | null | undefined {
    if (!contractType) {
      return contractType;
    }
    switch (contractType) {
      case 'CDD R':
        return 'Contrat à Durée Déterminée de Remplacement avec terme';
      case 'CDD RST':
        return 'Contrat à Durée Déterminée de Remplacement sans terme';
      case 'CDD A':
        return "Contrat à Durée Déterminée pour Accroissement d'activité";
      case 'CDI':
        return 'Contrat à Durée Indéterminée';
    }
  }
}
